import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import './BannerData.css'
import { adminFetch } from '../../../utils/api';
import NewBanner from '../NewBanner/NewBanner';
export default function BannerData() {
    const [banners, setBanners] = useState([]);
    useEffect(() => {
        cargarBanners();

    }, []);
    const cargarBanners = () => {
        adminFetch(`${baseURL}/api/banners`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setBanners(data.banner || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };
    const eliminarBanner = (idBanner) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                adminFetch(`${baseURL}/api/admin/banners/${idBanner}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarBanners();
                    })
                    .catch(error => {
                        console.error('Error al eliminar la Producto:', error);
                        toast.error(error);
                    });
            }
        });
    };
    return (
        <div className='BannerContainer'>
            <NewBanner />
            
            {/* Leyenda con resoluciones óptimas */}
            <div className='banner-resolution-guide'>
                <h3>📏 Resoluciones Óptimas para Banners</h3>
                <div className='resolution-info'>
                    <div className='resolution-item'>
                        <strong>📱 Móvil:</strong> 1200 x 628 píxeles
                    </div>
                    <div className='resolution-item'>
                        <strong>💻 Desktop:</strong> 1200 x 628 píxeles
                    </div>
                    <div className='resolution-item'>
                        <strong>🎯 Recomendación:</strong> Usar formato 1.91:1 (1200x628) para máxima compatibilidad
                    </div>
                </div>
                <div className='resolution-tips'>
                    <p>💡 <strong>Consejos:</strong></p>
                    <ul>
                        <li>Mantén el texto principal en el centro (zona segura)</li>
                        <li>Usa imágenes de alta calidad (mínimo 72 DPI)</li>
                        <li>Formato recomendado: JPG o PNG</li>
                        <li>Tamaño máximo: 30 MB</li>
                    </ul>
                </div>
            </div>
            
            <div className='BannerWrap'>
                {
                    banners.map(item => (
                        <div className='cardBanner'>
                            <img src={item.imagen} alt="banner" />
                            <button className='btnBannerDelete' onClick={() => eliminarBanner(item.idBanner)}>
                                <FontAwesomeIcon icon={faTrash} />
                            </button>
                        </div>
                    ))
                }

            </div>

        </div>
    )
}
